export const getMessage = (DefaultMessages: { [id: string]: string }) => (msg: string, params: any) => {
  let message = DefaultMessages[msg];
  if (params) {
    message = Object.keys(params).reduce((currentMsg, paramName) => {
      return currentMsg.replace(`{${paramName}}`, params[paramName]);
    }, message);
  }
  return message;
};
